module.exports = __webpack_public_path__ + "img/succes.d97e9324.png";